import React, { FunctionComponent } from "react";
import styles from "./Menu.module.scss";

import { HamburgerComponent } from "./hamburger/Hamburger.component";
import { useMenu } from "./useMenu";
import { MenuItemComponent } from "./menu-item/MenuItem.component";
import { mainMenu, MenuItem } from "./MainMenu";

export const MenuComponent: FunctionComponent = (): React.JSX.Element => {
  const { isHamburgerOpen } = useMenu();

  // const { library } = useWeb3React<providers.Web3Provider>();

  return (
    <>
      <ul
        className={[
          styles["menu"],
          isHamburgerOpen ? styles["visible"] : "",
        ].join(" ")}>
        {mainMenu.map((item: MenuItem) => {
          return (
            <MenuItemComponent
              key={item.index}
              index={item.index}
              title={item.title}
              icon={item.icon}
              collapsible={item.collapsible}
              disabled={item.disabled}
              tabKey={item.tabKey}
            />
          );
        })}
      </ul>

      {/* <ConnectButtonComponent /> */}

      <HamburgerComponent />
    </>
  );
};
